const getStringFrom = (wholeString: string, word: string): string => {
  if (wholeString === "" || word === "") {
    return "";
  }

  var remainingString = wholeString.split(word)[1].replace("%3D", "=");
  return remainingString;
};

export default getStringFrom;
